import M$plugin$ShareMap from './/facade/js/sharemap';
import M$control$ShareMapControl from './/facade/js/sharemapcontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
window.M.plugin.ShareMap = M$plugin$ShareMap;
window.M.control.ShareMapControl = M$control$ShareMapControl;
